import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=98bb719c&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98bb719c')) {
      api.createRecord('98bb719c', component.options)
    } else {
      api.reload('98bb719c', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=98bb719c&", function () {
      api.rerender('98bb719c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/Account/Widgets/ChangePassword.vue"
export default component.exports